export default __webpack_public_path__ + "static/media/goma.51fdacf0.png";